import { Component } from '@angular/core';

@Component({
  selector: 'blank-layout',
  templateUrl: './blank.component.html',
  styleUrls: []
})
export class BlankComponent {
}


// WEBPACK FOOTER //
// /Users/igor/Projects/onechat/admin-dashboard/src/app/layouts/blank/blank.component.ts